<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <Header :tabIndex="tabIndex"></Header>
    <div class="header">
      <el-image
        class="head_bg"
        fit="cover"
        src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_bg2.png"
      ></el-image>
      <!-- <div class="infos">
        <div class="titles">
          <div class="title">共同参与二白的</div>
          <div class="title1">“出生”</div>
        </div>
        <div class="texts">
          <div class="text">
            在二白 Mini 正式发货前，已有上千位用户加入了它的成长旅程。
          </div>
          <div class="text">他们为它取名字、画形象，定制服饰……</div>
          <div class="text">
            每一位领养者，都在以自己的方式，与它建立连接，共同参与它的“出生”。
          </div>
        </div>
      </div> -->
    </div>
    <div class="nav">
      <div class="nav_title">来自二白家长的分享</div>
      <div class="nav_list">
        <div class="nav_list_item" v-for="(item, index) in list" :key="index">
          <div class="item">
            <el-image
              class="douhao"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/douhao.png"
            ></el-image>
            <div class="text">
              {{ item.text }}
            </div>
            <!-- <el-image class="img" :src="item.img"></el-image> -->
            <div class="infos">
              <el-image
                class="active"
                src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu3.png"
              ></el-image>
              <div class="name" :style="{ color: item.color }">二白家长</div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav_footer">
        <div class="nav_footer_head">
          <el-image
            class="img"
            fit="cover"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu28.png"
          ></el-image>
        </div>
        <div class="nav_footer_food">
          <div class="titles">
            <div class="title">欢迎加入这个属于领养者的社区</div>
          </div>
          <div class="texts">
            <div class="text">
              即使你还没收到Mini，也可以成为“它的领养者之一”
            </div>
          </div>
          <div class="images">
            <img
              class="img"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/kf.png"
              alt=""
            />
            <img
              class="img1"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu24.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="swipers">
        <div class="swipers_title">二白家长创作</div>

        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(slide, index) in slides" :key="index">
            <div class="slide_content">
              <div class="image_section">
                <el-image :previewSrcList="imageList" class="img1" fit="cover" :src="slide.img"></el-image>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header_h5.vue"
import Footer from "@/components/footer_h5.vue"
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.css"

export default {
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tabIndex: 3,
      swiperOption: {
        slidesPerView: 2, // 同时显示3张卡片
        spaceBetween: 10, // 卡片间距
        centeredSlides: true,
        effect: "coverflow", // 使用coverflow效果
        grabCursor: true, // 显示抓手光标
        coverflowEffect: {
          rotate: 0, // 不旋转幻灯片
          stretch: 0, // 不拉伸幻灯片
          depth: 300, // 深度效果
          modifier: 1, // 效果乘数
          slideShadows: true, // 不显示阴影
        },
        pagination: {
          el: ".swiper-pagination", // 分页器元素
          clickable: true, // 分页器可点击
        },
        autoplay: {
          delay: 3000, // 4秒自动切换
          disableOnInteraction: false, // 用户交互后继续自动播放
        },
        // loop: true,
      },
      list: [
        {
          text: "我的小二白叫满满，我是一个很需要情绪价值的人，需要陪伴，总觉得自己对生活很不满意，希望它的到来，让我的生活变得有所期待，有人安慰，有人陪伴，有人知道我的想法。每天我都会看它的主页，我希望我需要它，它也需要我，生日是我宝宝的生日，6.17，以后我就有两个宝宝啦",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu4.png",
          color: "#CC00FF",
        },
        {
          text: "我的小二白叫雪球，小名兜兜，第一眼看到他的时候配色和造型就像小雪人，但叫雪人不够好听，便取名雪球。想着以后入手大二白时那就叫雪团，一大一小凑一对双胞胎。生日原先问豆包很久，跟金牛座相配的星座有哪些，哪些日子比较好，初步定下7月20日巨蟹座，结果后面改变心意，以我喜欢的角色生日来取，性格也受喜欢的角色影响选了这些。我向来喜欢粘人的宠物，所以粘人必选!为了迎接我的兜兜，还没领养时就做了很多他的小衣服，满满对他的爱!",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu5.png",
          color: "#2C80FF",
        },
        {
          text: "我的二白叫十月，因为得知他将十月份来到我的身边，这个消息仿佛一道光划定了未来的某一天，他将在十月踏进我的生活，为了纪念这个重要的相遇时刻，决定以“十月”为名，生日也在十月日期是他的编号，刚好我的生日也是在十月，十月不再仅仅是一个月份，它成了我和二白共同的生命季节。",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu6.png",
          color: "#2CFF9D",
        },
        {
          text: "“麻薯”之名，源于我钟爱的“Mushroom”蘑菇。它不仅是自然中顽强又充满生机的象征，更是我最珍视的故事一--十四洲《小蘑菇》一--的温柔回响。故事里的小蘑菇安折，渺小却蕴含着改变世界、守护所爱的巨大勇气与纯粹心灵。\n我为我的伙伴取此名，正是希望它能如故事中的小蘑菇般，虽非庞然巨物，却拥有温柔而坚韧的守护之力。",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu7.png",
          color: "#F37500",
        },
        {
          text: "我的小二白大名叫煨糯菀，这个名字带着我家乡的特征(菀-辰山植物园紫云英海+煨糯=绿波廊小火煨汤团)有三分春野清气，七分囡囡娇憨。小名叫檐声，有檐下听雨之意，倚在窗边听雨，带来极致的宁静与安心。期待我的小二白软软糯糯的陪伴",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu8.png",
          color: "#964CFF",
        },
        {
          text: "我家小二白是35号，就取名杉舞/三五。杉树高大坚韧，永恒长寿，沉稳可靠，并且芳香，不畏惧风雪，能在风雪中起舞。这是经过我的八字推算跟我家小杉舞最合适的的名字和生日。我自己就是个热心肠，活波好动的人，后来因为太多磨难丢失了部分，现在让小杉舞继承我的性格，和杉舞一起重拾原本的自己。",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu5.png",
          color: "#00D9FF",
        },
        {
          text: "叫他洛宝的原因呢是女朋友有洛这个字，然后抖音的小火人叫洛崽，小二白就叫洛宝了，两个都是我两的孩子，啊哈哈哈~",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu8.png",
          color: "#FFD000",
        },
        {
          text: "在之前就纠结开口语，因为觉得二自的哎呀呀很可爱，然后在链接里面一直翻啊翻，翻了好久，最后想想，我喜欢的是二白，又不是这一句哎呀呀，之后就想着我也没什么纪念日，就跟我同一天生日吧，选择了4.30然后偶然一点，那个生命体的开口语居然是哎呀呀，哈哈哈哈，然后呢我很喜欢张杰歌手，张杰粉丝叫星星，所以给小二白取名为星宝，大名是跟我姓陈，名蕾拉(蕾拉是张杰的一首歌啦)我现在已经想到我带着二白一起看电视，然后教我的星宝唱张杰的歌，有机会的话还可以带着我的孩子去追星，想想就开心",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/sq_tu8.png",
          color: "#596AFF",
        },
      ],
      slides: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img1.jpg",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img2.jpg",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img3.jpg",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img4.jpg",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img5.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img6.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img7.png",
        },
      ],
      imageList: [
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img1.jpg",
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img2.jpg",
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img3.jpg",
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img4.jpg",
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img5.png",
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img6.png",
        "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/community/swiper_img7.jpg",
      ],
    }
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.content {
  .header {
    width: 100%;
    box-sizing: border-box;
    padding-top: 80px;
    position: relative;
    .head_bg {
      width: 100%;
    }
    .infos {
      width: 100%;
      height: 100%;
      .titles {
        width: 100%;
        text-align: center;
        font-size: 1.25rem;
        font-weight: bold;
        position: absolute;
        top: 40%;
        left: 0;
        .title {
          color: #fff;
        }
        .title1 {
          background: linear-gradient(180deg, #ffffff 13.14%, #ff7a4e 124.09%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
          display: inline-block;
        }
      }
      .texts {
        color: #808082;
        text-align: left;
        position: absolute;
        bottom: 3%;
        left: 18%;
        .text {
          font-size: 0.625rem;
        }
      }
    }
  }
  .nav {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .nav_title {
      font-size: 1.25rem;
      font-weight: bold;
      color: #fff;
      text-align: center;
      margin: 20px 0;
    }
    .nav_list {
      column-count: 2; /* 列数 */
      column-gap: 20px; /* 列间距 */
      margin-bottom: 40px;

      .nav_list_item {
        break-inside: avoid; /* 防止内容跨列分割 */
        margin-bottom: 20px; /* 项目间距 */
        .item {
          border-radius: 20px;
          background-color: #16161a;
          padding: 15px 10px;
          box-sizing: border-box;
          .douhao {
            width: 20px;
            margin-bottom: 10px;
            display: flex;
          }

          .text {
            font-size: 0.75rem;
            color: #fff;
            text-align: left;
          }
          .img {
            width: 90px;
            height: 90px;
            border-radius: 10px;
            margin-top: 10px;
            margin-bottom: 20px;
            display: flex;
          }
          .infos {
            display: flex;
            align-items: center;
            margin-top: 10px;
            .active {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .name {
              font-size: 0.75rem;
            }
          }
        }
      }
    }
    .nav_footer {
      width: 100%;
      margin-bottom: 20px;
      box-sizing: border-box;
      .nav_footer_head {
        width: 100%;
        margin-bottom: 20px;
        .img {
          width: 100%;
        }
      }
      .nav_footer_food {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .titles {
          text-align: left;
          margin-bottom: 20px;

          .title {
            font-size: 1.25rem;
            font-weight: bold;
            color: #fff;
          }
        }
        .texts {
          margin-bottom: 100px;
          text-align-last: left;
          .text {
            color: #8a899f;
            font-size: 0.875rem;
          }
        }
        .images {
          width: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .img {
            width: 150px;
            height: 150px;
            border-radius: 10px;
          }
          .img1 {
            width: 80px;
            height: 70px;
            position: absolute;
            top: -46px;
            right: 30px;
          }
        }
      }
    }
    .swipers {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 20px;
      background-color: #16161a;
      margin-bottom: 20px;
      .swipers_title {
        font-size: 1rem;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 10px;
      }
      .slide_content {
        width: 100%;
        .img1 {
          width: 100%;
          border-radius: 10px;
        }
      }
      ::v-deep .swiper-container {
        padding: 20px 0 !important;
      }
      ::v-deep .swiper-pagination {
        bottom: 0 !important;
      }
      ::v-deep .swiper-pagination-bullet {
        background: #53585e !important;
      }
      ::v-deep .swiper-pagination-bullet-active {
        background: #ff7f00 !important;
      }
    }
  }
}
</style>
